import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AuthService} from "../../../../auth/auth.service";
import {Router} from "@angular/router";
import {PushNotificationService, PushState} from "../../../service/push-notification.service";
import {NAV_ITEMS} from "../../../nav-items";
import {ConfirmService} from "../../../../shared/confirm.service";
import {ToastService} from "../../../../shared/toast.service";

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css'],
    standalone: false
})
export class NavbarComponent implements OnInit {

  navItems = NAV_ITEMS;
  login = false;
  pushState: PushState = 'unsupported';
  pushBusy = false;

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly pushService: PushNotificationService,
    private readonly confirmService: ConfirmService,
    private readonly toast: ToastService,
    private readonly cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.login = this.authService.isLoggedIn();
    this.authService.isLoggedIn$.subscribe(isLoggedIn => {
      this.login = isLoggedIn;
      if (isLoggedIn) {
        this.refreshPushState();
      }
    });
  }

  get pushTitle(): string {
    switch (this.pushState) {
      case 'on': return 'Notifications on — tap to turn off';
      case 'blocked': return 'Notifications are blocked in browser settings';
      default: return 'Turn on notifications';
    }
  }

  async onTogglePush() {
    this.pushBusy = true;
    const wasOn = this.pushState === 'on';
    try {
      if (wasOn) {
        await this.pushService.disable();
      } else {
        await this.pushService.enable();
      }
      await this.refreshPushState();
      if (this.pushState === 'on') {
        this.toast.success('Notifications are on for this device');
      } else if (wasOn) {
        this.toast.info('Notifications turned off');
      }
    } catch (error) {
      console.error('Push notification toggle failed', error);
      await this.refreshPushState();
      this.toast.error(this.pushState === 'blocked'
        ? 'Notifications are blocked. Allow them in your browser settings.'
        : 'Could not change notifications. Please try again.');
    } finally {
      this.pushBusy = false;
      this.cdr.detectChanges();
    }
  }

  onLogin() {
    this.router.navigate(['/auth/login']);
  }

  async onLogOut() {
    const confirmed = await this.confirmService.confirm({
      title: 'Log out?',
      message: 'Notifications stop on this device until you log in again.',
      confirmLabel: 'Log out',
    });
    if (!confirmed) {
      return;
    }
    // Stop pushes to this device once nobody is logged in on it
    await this.pushService.disable().catch(() => {});
    this.authService.logout();
  }

  private async refreshPushState() {
    this.pushState = await this.pushService.getState();
    this.cdr.detectChanges();
  }
}
